export default "__VITE_PUBLIC_ASSET__31d0ff75__"